import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconCheckOff = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-check-off_svg__a)"
      d="M12 0c6.61 0 12 5.39 12 12 0 6.656-5.39 12-12 12-6.656 0-12-5.344-12-12C0 5.39 5.344 0 12 0Zm0 21.75c5.344 0 9.75-4.36 9.75-9.75 0-5.344-4.406-9.75-9.75-9.75-5.39 0-9.75 4.406-9.75 9.75 0 5.39 4.36 9.75 9.75 9.75Z"
    />
    <defs>
      <linearGradient
        id="icon-check-off_svg__a"
        x1={24}
        x2={0}
        y1={0}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF968D" />
        <stop offset={0.18} stopColor="#E2645A" />
        <stop offset={0.73} stopColor="#D83832" />
        <stop offset={1} stopColor="#AD3529" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconCheckOff;
